import { Button } from "reactstrap";
import React, {
  useState,
  useRef
} from "react";
import {
  Input,
  Label,
} from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import axios from "axios";
import { getAllCommercials } from "../../../store/slices/commericals";
import { getAccessToken } from "../../../api/baseApi";

const AddProducts = ({ collections, history, onSuccess }) => {
  const dispatch = useDispatch();
  const allPrograms = useSelector(
    (state) => state.programs.allProgramsData
  ).map((program) => ({
    label: program.name,
    value: program.slug_name,
  }));

  console.log(allPrograms, "all programs");
  

  const client = useSelector((state) => state.clients?.selectedClient?.value);
  const [commercialData, setCommercialData] = useState([]);
  const [formFields, setFormFields] = useState({
    name: "",
    collection_slug: "",
    service_slug: "complimentry_benefits",
    program_slug: "",
  });

  const {
    register,
    trigger,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      name: "",
      collection_slug: "",
      service_slug: "",
      program_slug: ""
    }
  });

  const handleInput = (event, field) => {
    let value;
    value = event.target.value;
    setValue(field, value);
    setFormFields({ ...formFields, [field]: value });
  };

  const fetchCommercials = async () => {
    let data = await dispatch(getAllCommercials())
    console.log(data.payload, "commercials data");
    const arrayData = data.payload.map((program) => ({
      label: program.discount_type,
      value: program.discount_type,
    }));
    setCommercialData(arrayData);
  };

  const [jsonData, setJsonData] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const content = e.target.result;
        const parsedJson = JSON.parse(content);
        setJsonData(parsedJson);
      } catch (error) {
        console.error("Error parsing JSON file:", error);
      }
    };

    if (file) {
      reader.readAsText(file);
    }
  };
  const handleSubmitProducts = async () => {

    if (!jsonData || !Array.isArray(jsonData) || jsonData.length === 0) {
      toast.error("Please upload a valid JSON file with data.");
      return;
    }
    let payload = {
      ...formFields,
      jsons: jsonData
    };
    const response = await axios.post(
      `${process.env.REACT_APP_PL_API}/products/createGenericProducts`,
      payload,
      {
        headers: {
          "x-tenant-id": client,
          "Content-Type": "application/json",
          "x-access-token": getAccessToken(client),
        },
      }
    );
    toast.success("Product added successfully");
    if (onSuccess) {
      onSuccess(formFields.collection_slug);
    }

  }

  React.useEffect(() => {
    if (collections) {
      setFormFields({ ...formFields, collection_slug: collections });
      setValue("collection_slug", collections);
    }
  }, [collections]);

  React.useEffect((
  ) => {
    fetchCommercials();
  }, []);

  return (
    <>
      <div className="card shadow-sm p-4 mt-4">
        <div className="card-body">

          <div className="mt-3">
            <Label>
              Name<span className="text-danger">*</span>
            </Label>
            <Input
              className="form-control digits"
              value={formFields.name}
              {...register("name", { required: "This field is required" })}
              onChange={(event) => handleInput(event, "name")}
            />
            {errors?.name && (
              <span className="mt-1 text-danger">{errors.name.message}</span>
            )}
          </div>

          <div className="mt-3">
            <Label>Select Collection</Label>
            <Input
              type="text"
              name="select"
              className="form-control digits"
              value={formFields.collection_slug}
              defaultValue={""}
              {...register("collection_slug", { required: "This field is required" })}
              onChange={(event) => handleInput(event, "collection_slug")}
              disabled
            />
            {errors?.collection_slug && (
              <span className="mt-1 text-danger">{errors.collection_slug.message}</span>
            )}
          </div>

          <div className="mt-3">
            <Label>Select Service</Label>
            <Input
              type="select"
              name="select"
              className="form-control digits"
              value={formFields.service_slug}

              {...register("service_slug", { required: "This field is required" })}
              onChange={(event) => handleInput(event, "service_slug")}
            >
              <option value="" disabled>
                -- Select Service --
              </option>

              {commercialData.map((service, index) => (
                <option key={index} value={service.value}>
                  {service?.label}
                </option>
              ))}
            </Input>
            {errors?.service_slug && (
              <span className="mt-1 text-danger">{errors.service_slug.message}</span>
            )}
          </div>

          <div className="mt-3">
            <Label>Select Plan</Label>
            <Input
              type="select"
              name="select"
              className="form-control digits"
              value={formFields.program_slug}
              defaultValue={""}
              {...register("program_slug", { required: "This field is required" })}
              onChange={(event) => handleInput(event, "program_slug")}
            >
              <option value="" disabled>
                -- Select Plan--
              </option>
              {allPrograms.map((service, index) => (
                <option key={index} value={service.value}>
                  {service?.label}
                </option>
              ))}
            </Input>
            {errors?.program_slug && (
              <span className="mt-1 text-danger">{errors.program_slug.message}</span>
            )}
          </div>

          <div className="mt-3">
            <input type="file" accept=".json" onChange={handleFileChange} />
            {jsonData && <pre>{JSON.stringify(jsonData, null, 2)}</pre>}
          </div>


          <div className="d-flex justify-content-center mt-4">
            <Button color="primary" onClick={() => handleSubmitProducts()}>
              Submit
            </Button>
          </div>

        </div>
      </div>
    </>

  );
};

export default AddProducts;
